import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "main-page-pc"
}
const _hoisted_2 = { style: {"display":"flex","justify-content":"center","width":"100%"} }
const _hoisted_3 = { style: {"display":"flex","justify-content":"center","width":"750px"} }
const _hoisted_4 = { class: "left-info" }
const _hoisted_5 = { style: {"width":"300px"} }
const _hoisted_6 = {
  key: 0,
  class: "main-page-mobile"
}
const _hoisted_7 = { style: {"display":"flex","flex-direction":"column","align-items":"center","justify-content":"center"} }
const _hoisted_8 = { style: {"margin-top":"8px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_ctx.isMobile == false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[4] || (_cache[4] = _createElementVNode("h3", { style: {"margin-top":"29px"} }, "Reservation update", -1)),
            _createElementVNode("h4", null, _toDisplayString(_ctx.hotelName), 1),
            _cache[5] || (_cache[5] = _createElementVNode("div", { style: {"width":"100%","height":"1px","background":"rgba(34, 34, 34, 0.1)","margin-top":"16px","margin-bottom":"40px"} }, null, -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "The link has expired", -1)),
                  _createElementVNode("p", _hoisted_5, [
                    _createTextVNode(" You can contact " + _toDisplayString(_ctx.hotelName) + " on ", 1),
                    _createElementVNode("u", null, _toDisplayString(_ctx.hotelPhoneNumber), 1),
                    _cache[0] || (_cache[0] = _createTextVNode(" or ", -1)),
                    _createElementVNode("u", null, _toDisplayString(_ctx.hotelEmail), 1)
                  ])
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "right-info" }, [
                  _createElementVNode("img", { src: "https://aeroguestblobstorageprod.blob.core.windows.net/illustrations/all Illustrations/316.Expired.svg" })
                ], -1))
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("div", { style: {"position":"absolute","bottom":"20px"} }, [
                _createElementVNode("img", { src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons/AeroGuest_Black.svg" })
              ], -1))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isMobile == true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", {
            style: _normalizeStyle([{ width: _ctx.windowWidth + 'px' }, {"position":"fixed","z-index":"100","top":"0","height":"31px","display":"flex","justify-content":"center","align-items":"center","padding":"16px","border-bottom":"2px solid #4aba96","background":"#fafafa"}])
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.hotelName), 1),
              _cache[6] || (_cache[6] = _createElementVNode("h5", null, "Reservation update", -1))
            ])
          ], 4),
          _createElementVNode("div", {
            style: _normalizeStyle([{ width: _ctx.windowWidth + 'px' }, {"margin-top":"64px","display":"flex","justify-content":"center","padding":"96px 16px"}])
          }, [
            _createElementVNode("div", null, [
              _cache[8] || (_cache[8] = _createElementVNode("img", {
                width: "200",
                height: "200",
                src: "https://aeroguestblobstorageprod.blob.core.windows.net/illustrations/all Illustrations/316.Expired.svg"
              }, null, -1)),
              _cache[9] || (_cache[9] = _createElementVNode("div", {
                class: "title",
                style: {"margin-top":"40px"}
              }, "The link has expired", -1)),
              _createElementVNode("p", _hoisted_8, [
                _createTextVNode(" You can contact " + _toDisplayString(_ctx.hotelName) + " on ", 1),
                _createElementVNode("u", null, _toDisplayString(_ctx.hotelPhoneNumber), 1),
                _cache[7] || (_cache[7] = _createTextVNode(" or ", -1)),
                _createElementVNode("u", null, _toDisplayString(_ctx.hotelEmail), 1)
              ])
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"position":"absolute","bottom":"20px"} }, [
              _createElementVNode("img", { src: "https://aeroguestblobstorageprod.blob.core.windows.net/icons/AeroGuest_Black.svg" })
            ], -1))
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}